import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "../locale/en";
import { es } from "../locale/es";

const STORAGE_KEY = "reword_i18n_language";

function readStoredLang(): "en" | "es" {
  if (typeof window === "undefined") return "en";
  const v = localStorage.getItem(STORAGE_KEY);
  return v === "es" ? "es" : "en";
}

const resources = {
  en,
  es,
};

i18n.use(initReactI18next).init({
  resources,
  lng: readStoredLang(),
  fallbackLng: "en",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  const normalized = lng?.startsWith("es") ? "es" : "en";
  localStorage.setItem(STORAGE_KEY, normalized);
});

export default i18n;
